export const services = [
  {
    id: "standard",
    title: "Standard Clean",
    blurb: "Weekly or bi-weekly upkeep that keeps every room effortlessly fresh.",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20minimalist%20living%20room%20interior%20with%20cream%20walls%20linen%20sofa%20and%20fresh%20greenery%2C%20soft%20natural%20daylight%20streaming%20through%20sheer%20curtains%2C%20warm%20wood%20floor%2C%20editorial%20interior%20photography%20muted%20sage%20palette%20calm%20clean%20serene%20atmosphere&width=900&height=1200&seq=service-standard-01&orientation=portrait",
    icon: "ri-home-smile-line",
  },
  {
    id: "deep",
    title: "Deep Clean",
    blurb: "An end-to-end refresh that reaches every overlooked corner of the home.",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20with%20marble%20countertop%20cream%20cabinets%20and%20brass%20fixtures%2C%20freshly%20cleaned%20surfaces%20gleaming%2C%20soft%20natural%20window%20light%2C%20small%20linen%20cloth%20and%20glass%20spray%20bottle%2C%20editorial%20home%20photography%20warm%20neutral%20tones&width=900&height=1200&seq=service-deep-02&orientation=portrait",
    icon: "ri-sparkling-2-line",
  },
  {
    id: "move",
    title: "Move-Out Clean",
    blurb: "A spotless handover for your new tenants, landlord, or property manager.",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20freshly%20cleaned%20apartment%20bedroom%20with%20wood%20floors%20cream%20walls%20single%20cardboard%20box%20by%20doorway%2C%20natural%20afternoon%20light%2C%20editorial%20interior%20photography%20minimalist%20warm%20neutral%20atmosphere%20calm%20peaceful&width=900&height=1200&seq=service-moveout-03&orientation=portrait",
    icon: "ri-truck-line",
  },
  {
    id: "airbnb",
    title: "Airbnb Turnover",
    blurb: "Fast, reliable resets for short-stay hosts who care about five-star reviews.",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20designer%20guest%20bedroom%20with%20crisp%20white%20linen%20bedding%20cream%20walls%20and%20woven%20textures%2C%20fresh%20towels%20rolled%20on%20bed%2C%20soft%20morning%20light%2C%20editorial%20hospitality%20photography%20serene%20warm%20neutral%20palette&width=900&height=1200&seq=service-airbnb-04&orientation=portrait",
    icon: "ri-key-2-line",
  },
] as const;

export const howItWorksSteps = [
  {
    number: "01",
    title: "Tell us about your home",
    blurb: "Share your address, square footage and the rooms that need attention.",
  },
  {
    number: "02",
    title: "Pick a date that fits",
    blurb: "Choose any time slot — same day, weekend, or a recurring rhythm.",
  },
  {
    number: "03",
    title: "Match with a cleaner",
    blurb: "See verified profiles, hourly rates and live reviews before you confirm.",
  },
  {
    number: "04",
    title: "Relax, we handle the rest",
    blurb: "Your cleaner arrives on time and you only pay after the job is done.",
  },
];

export const stats = [
  { value: "12,400+", label: "Homes refreshed" },
  { value: "4.9", label: "Average rating" },
  { value: "320+", label: "Vetted cleaners" },
  { value: "98%", label: "Rebook rate" },
];

export const pricingPlans = [
  {
    name: "Tidy",
    price: "$89",
    cadence: "per visit",
    features: [
      "Up to 2 hours of cleaning",
      "Kitchen, bath & living room",
      "Eco-friendly products",
      "Weekday morning slots",
    ],
    cta: "Book a Tidy",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Soft%20sage%20green%20minimalist%20background%20with%20a%20single%20glass%20spray%20bottle%20linen%20cloth%20and%20small%20olive%20branch%20arranged%20artfully%2C%20editorial%20product%20photography%20warm%20natural%20light%20calm%20peaceful%20composition&width=800&height=900&seq=price-tidy-01&orientation=portrait",
  },
  {
    name: "Standard",
    price: "$149",
    cadence: "per visit",
    features: [
      "Up to 4 hours of cleaning",
      "All rooms, dust, mop & vacuum",
      "Eco-friendly products",
      "Anytime slots, 7 days a week",
      "Free reschedule",
    ],
    cta: "Book a Standard",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20minimalist%20background%20with%20stacked%20folded%20linen%20towels%20a%20small%20wooden%20brush%20and%20fresh%20eucalyptus%20sprig%2C%20editorial%20product%20photography%20soft%20natural%20light%20harmonious%20composition%20neutral%20tones&width=800&height=900&seq=price-standard-02&orientation=portrait",
  },
  {
    name: "Deep",
    price: "$249",
    cadence: "per visit",
    features: [
      "Up to 7 hours of cleaning",
      "Inside oven, fridge & cabinets",
      "Window sills & baseboards",
      "Two cleaners per visit",
      "Priority booking line",
    ],
    cta: "Book a Deep",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20terracotta%20minimalist%20background%20with%20a%20ceramic%20bowl%20natural%20bristle%20brush%20and%20small%20bottle%20of%20essential%20oil%2C%20editorial%20product%20photography%20soft%20directional%20natural%20light%20earthy%20neutral%20palette%20calm&width=800&height=900&seq=price-deep-03&orientation=portrait",
  },
];

export const cleaners = [
  {
    id: "1",
    name: "Maya Olsen",
    role: "Senior Cleaner · 6 yrs",
    rate: "$32/hr",
    rating: 4.96,
    jobs: 612,
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20in%20her%2030s%20smiling%20warmly%20wearing%20clean%20olive%20green%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20trustworthy&width=600&height=720&seq=cleaner-01&orientation=portrait",
  },
  {
    id: "2",
    name: "Daniel Reyes",
    role: "Deep-Clean Specialist · 4 yrs",
    rate: "$36/hr",
    rating: 4.92,
    jobs: 438,
    image:
      "https://readdy.ai/api/search-image?query=Confident%20professional%20male%20house%20cleaner%20in%20his%20late%2020s%20smiling%20kindly%20wearing%20clean%20beige%20uniform%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20friendly%20reliable&width=600&height=720&seq=cleaner-02&orientation=portrait",
  },
  {
    id: "3",
    name: "Aisha Bennett",
    role: "Eco Clean Lead · 5 yrs",
    rate: "$34/hr",
    rating: 5.0,
    jobs: 521,
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20in%20her%20late%2020s%20warm%20smile%20wearing%20clean%20sage%20green%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable&width=600&height=720&seq=cleaner-03&orientation=portrait",
  },
  {
    id: "4",
    name: "Liam Hartwell",
    role: "Move-Out Pro · 3 yrs",
    rate: "$30/hr",
    rating: 4.88,
    jobs: 287,
    image:
      "https://readdy.ai/api/search-image?query=Professional%20male%20house%20cleaner%20in%20his%20early%2030s%20gentle%20smile%20wearing%20clean%20cream%20uniform%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20friendly%20trustworthy&width=600&height=720&seq=cleaner-04&orientation=portrait",
  },
];

export const testimonials = [
  {
    quote:
      "I came home to a sunlit, sparkling apartment and a little olive branch on the counter. It honestly felt like a tiny vacation.",
    name: "Eleanor Whitcombe",
    location: "Brookline · weekly customer",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20woman%20in%20her%2040s%20with%20short%20auburn%20hair%20smiling%20gently%20against%20a%20soft%20cream%20background%2C%20editorial%20photography%20natural%20light%20approachable%20professional&width=200&height=200&seq=test-avatar-01&orientation=squarish",
  },
  {
    quote:
      "Booking took ninety seconds and Daniel finished in three hours. The before-and-after photos he sent are now on my fridge.",
    name: "Marcus Cole",
    location: "South End · monthly customer",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20man%20in%20his%20mid%2030s%20with%20short%20dark%20hair%20friendly%20smile%20against%20a%20soft%20cream%20background%2C%20editorial%20photography%20natural%20light%20approachable&width=200&height=200&seq=test-avatar-02&orientation=squarish",
  },
  {
    quote:
      "We host three Airbnbs and PureNest handles every turnover. Our five-star streak hasn't broken in eight months — that's wild.",
    name: "Priya Anand",
    location: "Allston · Airbnb host",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20woman%20in%20her%20early%2030s%20with%20long%20dark%20hair%20bright%20smile%20against%20a%20soft%20cream%20background%2C%20editorial%20photography%20natural%20light%20professional%20approachable&width=200&height=200&seq=test-avatar-03&orientation=squarish",
  },
];

export const faqs = [
  {
    q: "What's included in a standard clean?",
    a: "Every standard visit covers kitchen surfaces, bathrooms, dusting, floors, trash and bed making. You can add laundry, oven, fridge or windows at booking.",
  },
  {
    q: "Are cleaners background-checked and insured?",
    a: "Yes. Every PureNest cleaner passes a multi-state background check, identity verification and an in-person craft assessment. We carry $2M in liability coverage on every job.",
  },
  {
    q: "What if I'm not happy with the result?",
    a: "We back every visit with a 24-hour Pure Promise. If anything is missed, we send a cleaner back the next day to fix it — at no extra cost.",
  },
  {
    q: "Can I keep the same cleaner each visit?",
    a: "Absolutely. Once you find a cleaner you click with, you can lock them in as your default for every recurring appointment.",
  },
  {
    q: "How do I pay?",
    a: "You add a card at booking and we only charge after your cleaner finishes the visit. Tips and recurring discounts are handled automatically.",
  },
  {
    q: "Do you bring supplies?",
    a: "Yes. Cleaners arrive with eco-certified products, microfiber cloths, mops and a HEPA vacuum. If you prefer your own products, just let us know in the booking notes.",
  },
];

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "How it works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "Cleaners", href: "#cleaners" },
  { label: "FAQ", href: "#faq" },
];